function loadRemoteScript(url, { timeoutDelay = 10000 } = {}, cancelRequest = undefined) {
    return new Promise((resolve, reject) => {
        const element = document.createElement('script');
        element.src = url;
        element.type = 'text/javascript';
        element.async = true;
        let timeoutId = undefined;
        let hasCanceled = false;
        function cancel(error) {
            hasCanceled = true;
            element?.parentElement?.removeChild(element);
            reject({
                error,
                hasCanceled: true,
            });
        }
        cancelRequest?.signal.addEventListener('abort', () => {
            cancel();
        });
        element.onload = async () => {
            clearTimeout(timeoutId);
            element?.parentElement?.removeChild(element);
            resolve({});
        };
        element.onerror = (error) => {
            if (!hasCanceled) {
                clearTimeout(timeoutId);
                element?.parentElement?.removeChild(element);
                reject({
                    error,
                    hasCanceled: false,
                });
            }
        };
        document.head.appendChild(element);
        // Eagerly reject the loading of a script, it's too long when a remote is unavailable.
        timeoutId = setTimeout(() => {
            cancel(new Error(`[shell] Remote script "${url}" time-outed after ${timeoutDelay} seconds.`));
        }, timeoutDelay);
    });
}
// Implementation of https://webpack.js.org/concepts/module-federation/#dynamic-remote-containers.
// It's done this way rather than using the managed mechanism provided with ModuleFederationPlugin config because it's doesn't throw an error if a module is not available.
export async function loadRemote(url, containerName, moduleName, options = {}, cancelRequest = undefined) {
    await loadRemoteScript(url, options, cancelRequest);
    // Initializes the share scope. It fills the scope with known provided modules from this build and all remotes.
    await __webpack_init_sharing__('default');
    // Retrieve the module federation container.
    const container = window[containerName];
    if (!container) {
        throw new Error(`[shell] Container "${containerName}" is not available for remote "${url}".`);
    }
    // Initialize the container, it may provide shared modules.
    // @ts-ignore
    await container.init(__webpack_share_scopes__.default);
    // Retrieve the module.
    // @ts-ignore
    const factory = await container.get(moduleName);
    if (!factory) {
        throw new Error(`[shell] Module "${module}" is not available for container "${containerName}" of remote "${url}".`);
    }
    return factory();
}
// Implementation of https://webpack.js.org/concepts/module-federation/#dynamic-remote-containers.
// It's done this way rather than using the managed mechanism provided with ModuleFederationPlugin config because it's doesn't throw an error if a module is not available.
export async function getRemoteContainer(url, containerName, options = {}, cancelRequest = undefined) {
    try {
        await loadRemoteScript(url, options, cancelRequest);
    }
    catch (error) {
        throw new Error(`[shell] Remote script "${url}" time-outed.`, error);
    }
    // Initializes the share scope. It fills the scope with known provided modules from this build and all remotes.
    await __webpack_init_sharing__('default');
    // Retrieve the module federation container.
    const container = window[containerName];
    if (!container) {
        throw new Error(`[shell] Container "${containerName}" is not available for remote "${url}".`);
    }
    // Initialize the container, it may provide shared modules.
    // @ts-ignore
    await container.init(__webpack_share_scopes__.default);
    return container;
}
export async function loadRemoteModule(url, containerName, moduleName, options = {}, cancelRequest = undefined) {
    // Initialize the container, it may provide shared modules.
    // @ts-ignore
    const container = await getRemoteContainer(url, containerName, options, cancelRequest);
    // Retrieve the module.
    // @ts-ignore
    const factory = await container.get(moduleName);
    if (!factory) {
        throw new Error(`[shell] Module "${module}" is not available for container "${containerName}" of remote "${url}".`);
    }
    return factory();
}
